const normalizeUrl = (value: string | undefined, name: string): string => {
  const normalized = value?.trim().replace(/\/$/, '');
  if (!normalized) throw new Error(`${name} is required.`);

  try {
    return new URL(normalized).toString().replace(/\/$/, '');
  } catch {
    throw new Error(`${name} must be an absolute URL.`);
  }
};

export const appEnv = Object.freeze({
  apiBaseUrl: normalizeUrl(import.meta.env.VITE_API_URL, 'VITE_API_URL'),
  isDevelopment: import.meta.env.DEV,
  mode: import.meta.env.MODE,
});
